import React from "react";
import { Link } from "react-router";
import {
  PoweroffOutlined,
  PlayCircleOutlined,
} from "@ant-design/icons";
const WorkerBottomBar = () => {

  const logOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("UserData");
    window.location.href = "/";
  };
  return (
    <div className="fixed z-50  w-full h-20 max-w-xl -translate-x-1/2 bg-white border border-gray-200 bottom-0 left-1/2 dark:bg-gray-700 dark:border-gray-600">
      <div className="grid h-full max-w-lg grid-cols-2 mx-auto">
        <button
          type="button"
          className="inline-flex flex-col items-center justify-center px-5  hover:bg-gray-50 dark:hover:bg-gray-800 group"
        >
          <Link to="/">
            <PlayCircleOutlined className="text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500 text-3xl" />
          </Link>
        </button>
        <button
          type="button"
          className="inline-flex flex-col items-center justify-center px-5 hover:bg-gray-50 dark:hover:bg-gray-800 group"
          onClick={logOut}
        >
          <PoweroffOutlined  className="text-gray-500 dark:text-gray-400 group-hover:text-blue-600 dark:group-hover:text-blue-500 text-3xl"/>
        </button>

      </div>
    </div>
  );
};

export default WorkerBottomBar;
